module.exports = __webpack_public_path__ + "static/img/bg-overview@m.18898e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezn-foundation/bg-overview@m.jpg
// module id = dLOD
// module chunks = 0